import { defineMessages } from "react-intl";
export default defineMessages({
    alreadyHaveAccount: {
        id: "auth.alreadyHaveAccount",
        defaultMessage: "Already have an account?",
    },
    authContainerTagline: {
        id: "auth.authContainerTagline",
        defaultMessage: "Your personal weather dashboard. Connect your stations and get real-time data at your fingertips.",
    },
    backToLogin: {
        id: "auth.backToLogin",
        defaultMessage: "Back to login",
    },
    catchPhrase: {
        id: "auth.catchPhrase",
        defaultMessage: "The Weather Intelligence Platform",
    },
    checkYourEmail: {
        id: "auth.checkYourEmail",
        defaultMessage: "Check your email",
    },
    continueWithApple: {
        id: "auth.continueWithApple",
        defaultMessage: "Continue with Apple",
    },
    continueWithFacebook: {
        id: "auth.continueWithFacebook",
        defaultMessage: "Continue with Facebook",
    },
    continueWithGoogle: {
        id: "auth.continueWithGoogle",
        defaultMessage: "Continue with Google",
    },
    email: {
        id: "auth.email",
        defaultMessage: "Email address",
    },
    emailRequiredLoginFacebook: {
        id: "auth.emailRequiredLoginFacebook",
        defaultMessage: "Email permission is required.",
    },
    emailVerification: {
        id: "auth.emailVerification",
        defaultMessage: "Email verification",
    },
    emailVerificationFailure: {
        id: "auth.emailVerificationFailure",
        defaultMessage: "A problem occurred with your email verification.",
    },
    emailVerificationSuccess: {
        id: "auth.emailVerificationSuccess",
        defaultMessage: "Your email has been successfully verified.",
    },
    firstName: {
        id: "auth.firstName",
        defaultMessage: "First name",
    },
    forgotPassword: {
        id: "auth.forgotPassword",
        defaultMessage: "Forgot your password?",
    },
    forgotPasswordSubtitle: {
        id: "auth.forgotPasswordSubtitle",
        defaultMessage: "Enter your email and we'll send you a link to reset your password.",
    },
    lastName: {
        id: "auth.lastName",
        defaultMessage: "Last name",
    },
    login: {
        id: "auth.login",
        defaultMessage: "Login",
    },
    loginSubtitle: {
        id: "auth.loginSubtitle",
        defaultMessage: "Welcome back! Please enter your details.",
    },
    loginToSmartMixinDescription: {
        id: "auth.loginToSmartMixinDescription",
        defaultMessage: "Sign in to SmartMixin to access your weather stations, view analytics, and manage your personal weather dashboard.",
    },
    logout: {
        id: "auth.logout",
        defaultMessage: "Logout",
    },
    logoutConfirmation: {
        id: "auth.logoutConfirmation",
        defaultMessage: "Are you sure you want to logout?",
    },
    noAccountYet: {
        id: "auth.noAccountYet",
        defaultMessage: "Don't have an account?",
    },
    or: {
        id: "auth.or",
        defaultMessage: "or",
    },
    password: {
        id: "auth.password",
        defaultMessage: "Password",
    },
    passwordAgain: {
        id: "auth.passwordAgain",
        defaultMessage: "Password again",
    },
    passwordReset: {
        id: "auth.passwordReset",
        defaultMessage: "Password reset",
    },
    passwordResetSuccess: {
        id: "auth.passwordResetSuccess",
        defaultMessage: "Your password has been successfully updated.",
    },
    register: {
        id: "auth.register",
        defaultMessage: "Create account",
    },
    registerDescription: {
        id: "auth.registerDescription",
        defaultMessage: "Create a free SmartMixin account to connect your weather stations, track weather data, and access powerful analytics tools.",
    },
    registerSubtitle: {
        id: "auth.registerSubtitle",
        defaultMessage: "Create your account to get started.",
    },
    registerSuccess: {
        id: "auth.registerSuccess",
        defaultMessage: "You've successfully registered! We've just sent you a verification link at {emailAddress} with further instructions.",
    },
    restorePassword: {
        id: "auth.restorePassword",
        defaultMessage: "Restore Password",
    },
    restorePasswordSuccess: {
        id: "auth.restorePasswordSuccess",
        defaultMessage: "We've just sent you a password reset link at {emailAddress} with further instructions.",
    },
    sendReset: {
        id: "auth.sendReset",
        defaultMessage: "Send reset instructions",
    },
    socialAccount: {
        id: "auth.socialAccount",
        defaultMessage: "or use your account",
    },
    welcome: {
        id: "auth.welcome",
        defaultMessage: "Welcome to SmartMixin",
    },
    welcomeBack: {
        id: "auth.welcomeBack",
        defaultMessage: "Welcome back!",
    },
});
